<template>
    <div class="home">
        <!--<div class="header">-->
        <!--<van-cell title="当前号码"  :value="phone" />-->
        <!--<van-cell title="实时话费" is-link :value="fee" to="fee"/>-->
        <!--<van-cell title="当前余额"  :value="balance" />-->
        <!--</div>-->
        <div class="slider">
            <van-swipe :autoplay="3000" indicator-color="white">
                <van-swipe-item>
                    <van-image :src="require('../../assets/img/slider1.png')" />
                </van-swipe-item>
                <van-swipe-item>
                    <a href="http://www.mystaffoffer.com/10030">
                        <van-image :src="require('../../assets/img/slider3.png')" />
                    </a>
                </van-swipe-item>
                <!--<van-swipe-item>3</van-swipe-item>-->
                <!--<van-swipe-item>4</van-swipe-item>-->
            </van-swipe>



            <!--<van-swipe :autoplay="3000">-->
                <!--<van-swipe-item v-for="(image, index) in images" :key="index">-->
                    <!--<img v-lazy="image" />-->
                <!--</van-swipe-item>-->
            <!--</van-swipe>-->
        </div>
        <div class="menu">
            <!--<van-icon name="gold-coin" />-->
            <!--<van-icon name="underway" />-->
            <van-grid clickable :column-num="3">
                <van-grid-item   v-if="!loginFlag" style='color: rgb(25, 137, 250);'  icon="friends-o" text="登录" to="/codelogin"/>
                <van-grid-item   v-else   @click="loginOut" style='color: rgb(25, 137, 250);'  icon="friends-o" text="登出" />
                <!--<van-icon name="friends-o" />-->
                <van-grid-item style='color: rgb(250,86,4)'  icon="gold-coin" text="充值缴费" to="/charge/" />
                <van-grid-item style='color: rgb(25, 137, 250);'   icon="bill" text="缴费历史" to="/rechargeorder"/>

                <!--<van-grid-item style='color: rgb(25, 137, 250);'  icon="underway" text="套餐使用量" to="/" />-->
                <!--<van-grid-item style='color: rgb(120,250,218);'  icon="balance-list" text="月账单" to="/" />-->
                <!--<van-grid-item style='color: green' icon="gold-coin" text="实时话费" to="/fee" />-->
                <!--<van-grid-item style='color: rgb(25, 137, 250);'  icon="underway" text="套餐使用量" to="/" />-->
                <van-grid-item style='color: green' icon="gold-coin" text="实时话费" to="/fee" />

                <van-grid-item style='color: rgb(120,250,218);' icon="balance-list" text="月账单" to="/bill" />
                <van-grid-item   v-if="loginFlag" style='color: rgb(25, 137, 250);'  icon="friends-o" text="重置密码" to="/reset"/>

                <!--<van-grid-item style='color: rgb(25, 137, 250);'  icon="underway" text="套餐使用量" to="/" />-->
                <!--<van-grid-item style='color: rgb(120,250,218);' icon="balance-list" text="月账单" to="/bill" />-->
                <!--<van-grid-item style='color: rgb(250,86,4);'  icon="card" text="号码激活" to="/actorder" />-->

                <!--<van-grid-item style='color: rgb(25, 137, 250);'  icon="comment" text="测试" to="/actcharge" />-->

                <!--<van-button type="default" @click="click">测试</van-button>-->
                <!--<van-grid-item style='color: rgb(25, 137, 250);'  icon="shop" text="选号入网" to="/" />-->
                <!--<van-grid-item style='color: red'  icon="shopping-cart" text="福利商城" url="http://www.mystaffoffer.com/10030" />-->
                <!--&lt;!&ndash;<van-icon class="iconfont" class-prefix='icon' name='shouye' />&ndash;&gt;-->
				<van-grid-item style='color: rgb(120,250,218);' :icon="icon.cardQuerySrc" text="名下号码查询" to="/rep/my-service-nums" />
				<van-grid-item style='color: rgb(120,250,218);' icon="cross" text="预约销户" to="/userOff/index" />
				<van-grid-item style='color: rgb(120,250,218);' icon="cross" text="协议变更" to="/faq/protocol2023" />
				<van-grid-item style='color: rgb(120,250,218);' :icon="icon.foreignerSrc" text="外国人永居证激活" to="/activate/foreigner" />
				<van-grid-item style='color: rgb(250,86,4);' icon="chat-o" text="短信免打扰" to="/wishes/sms" />
            </van-grid>
        </div>
        <div class="footer">
            <Footer></Footer>
        </div>
    </div>
</template>
<script>
    // import {mapActions, mapGetters,mapState} from 'vuex'
    // import { weixinStorage,vuexStorage,codeloginApi } from '@/api/login'
    import { weixinStorage,vuexStorage,codeloginApi,loginOut,getCookie} from '@/api/login'
    import Footer from '@/view/footer'
    import  img1  from   '@/assets/img/slider1.png'
    import  img2  from   '@/assets/img/slider2.png'
	import cardQuerySrc  from '@/assets/img/card-query.jpg'
	import foreignerSrc  from '@/assets/img/foreigner-back.png'
    export default {
        name: "index",
        data() {
            return {
                phone: '17008187835',
                fee: '10.00',
                balance: '300.00',
                images: [
                    img1,
                    img2,
                ],
				icon:{
					cardQuerySrc:cardQuerySrc,
					foreignerSrc:foreignerSrc,
				}
				
            };
        },
        components: {
            Footer
        },
        methods:{
            click(){
                this.$router.push('charge/act');

            },

            loginOut(){
                console.log(getCookie('token'))
                loginOut()
                this.$router.push('codelogin');
            }
        },
        computed: {
            loginFlag:function () {
                console.log(getCookie('token'))
                if(getCookie('token')){
                    return  true
                }
                else {
                    return  false

                }
            }
           }
    }
</script>

<style scoped>
    .my-swipe .van-swipe-item {
        color: #fff;
        font-size: 20px;
        line-height: 150px;
        text-align: center;
        background-color: #39a9ed;
    }
</style>
